import PageApp from 'pageApp';
import Util from '../../util/Util';
import KillSwitchUtil from '../../util/KillSwitchUtil';

export default class PurchaseDetailPage {
  constructor(mainPageController) {
    this.mainPageController = mainPageController;
    this.model = this.mainPageController.options.data;
    this.selector = mainPageController.selector;
    this.verticalZone = this.selector.filter('.vertical');
  }

  getFirstProductOfFirstOrder() {
    if (this.model) {
      const shipments = this.model.get('shipments');
      if (shipments && shipments.length && shipments[0].items && shipments[0].items.length) {
        return shipments[0].items[0].product.id;
      }
    }
    return undefined;
  }

  apply() {
    let proceed = false;
    if (KillSwitchUtil.isTrue('prosZoneStoresPurchasesEnabled')) {
      const productId = this.getFirstProductOfFirstOrder();
      if (productId) {
        proceed = true;
        this.mainPageController.selector.data('productid', productId);
        if (Util.isMobile()) {
          this.verticalZone.removeClass('prosPanel');
        }
      }
    } else {
      PageApp.channel.trigger('hide:pros:panels', '#order-details-container');
      proceed = false;
    }
    return Promise.resolve(proceed);
  }
}
